import { render, staticRenderFns } from "./CollectionLoader.vue?vue&type=template&id=448c1cbb&"
import script from "./CollectionLoader.vue?vue&type=script&lang=js&"
export * from "./CollectionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports